import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import Radio from '@womcorp/wom-miwom-ui-kit/dist/components/RadioButton/Radio';
import Panel from '@womcorp/wom-miwom-ui-kit/dist/components/Panel';
import MessageCard from '@womcorp/wom-miwom-ui-kit/dist/components/Cards/MessageCard';
import Spinner from '@womcorp/wom-miwom-ui-kit/dist/components/Spinner';

import Button from '@womcorp/wom-miwom-ui-kit/dist/components/Button';
import { OneCardIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons';
import { Link } from 'gatsby';
import AppContext from '../../App/AppContext';
import Auth from '../../../services/Auth';
import BffPaymentManagement from '../../../services/BFF/PaymentManagement';
import {
  ContainerRadioButtonStyled,
  ContainerRadioGroupStyled,
  DisclaimerErrorStyled,
  DisclaimerKushkiStyled,
  DisclaimerWompayStyled,
  ModalContainerStyled,
  ModalStyled,
  PayChipStyled,
  PayContainerStyled,
  PayInfoContainerStyled,
  SelectorPaymentMethodStyled,
  TitleSelectorStyled,
} from './styles/PayButtonStyled';
import {
  GoogleTagManager,
  Numbers,
  redirectToExternalPage,
} from '../../../helpers';
import { redirectToWompay } from '../../../helpers/Redirect';
import LoadingComponent from '../../App/LoadingComponent';
import useUser from '../../../hooks/useUser';
import { useGlobalData } from '../../../contextProvider/GlobalDataContext';

const PayButton = ({
  title,
  icon,
  invoicesStatus,
  paymentUrl,
  last6Invoices,
  accountSelected,
}) => {
  const allInvoices = [
    last6Invoices?.lastInvoice,
    ...last6Invoices?.lastSemester,
  ];
  const { isEnabled = { wompay: false } } = useGlobalData();

  const isWompayEnabled = isEnabled.wompay;

  const { hasKushkiCards } = useContext(AppContext);
  const accountNumber = accountSelected || Auth.getAccountId();
  const {
    user: { rut },
  } = useUser();

  const [loading, setLoading] = useState(false);
  const [showPanel, setShowPanel] = useState(false);
  const [transactionIdWomPay, setTransactionIdWomPay] = useState(0);
  const [payWithWompay, setPayWithWompay] = useState(false);
  const [payWithOtherWay, setPayWithOtherWay] = useState(false);

  const generateItem = itemToPay => {
    const { amount, documentId, status } = itemToPay;
    if (status !== 'paid') {
      return {
        productfolio: documentId,
        productId: '',
        productGloss: 'Boleta movil',
        productQuantity: 1,
        productUnitAmount: amount,
      };
    }
    return null;
  };

  const generatePayload = () => {
    const currentDate = new Date().toISOString();
    const currentDomain = window.location.origin;
    const totalAmountTransaction = invoicesStatus?.amountToPay;
    const myProducts = allInvoices
      .map(generateItem)
      .filter(item => item !== null);
    return {
      idChannel: 'MiWOM',
      channelEntryDate: currentDate,
      channelUrlRedirectToEnd: `${currentDomain}/home`,
      totalAmountTransaction,
      items: [
        {
          accountNumber,
          totalAmountAccountNumber: totalAmountTransaction,
          typeDebit: 'services_movil',
          products: myProducts,
        },
      ],
      typePayment: 'attended',
      rut,
    };
  };
  useEffect(() => {
    if (showPanel) {
      GoogleTagManager.tagInteractiveEvent({
        eventCategory: 'Status Bar',
        eventAction: `Presionar Botón - Status bar - Ir a pagar`,
        eventTag: `Presionar Botón - Status bar - Ir a pagar`,
      });
      GoogleTagManager.pushToDataLayer({
        event: 'pagina-virtual',
        page: '/modal-medios-pagos/',
        pagename: 'Modal Medios de Pago',
      });

      if (!hasKushkiCards) {
        if (!loading) setLoading(true);
        BffPaymentManagement.generateTransactionId(generatePayload())
          .then(([{ transactionId }]) => {
            setTransactionIdWomPay(transactionId);
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
            setPayWithOtherWay(true);
            GoogleTagManager.pushToDataLayer({
              event: 'pagina-virtual',
              page: '/medios-pagos/error-wompay',
              pagename: 'Medios de pago - Error Wompay',
            });
          });
      }
    }
  }, [showPanel]);

  if (!isWompayEnabled) {
    return (
      <Button
        color="bubbleGum"
        endIcon={icon || null}
        onClick={() => redirectToExternalPage(paymentUrl, false)}
      >
        {title}
      </Button>
    );
  }

  const resetValues = () => {
    setPayWithWompay(false);
    setPayWithOtherWay(false);
    setLoading(false);
    setTransactionIdWomPay(0);
  };

  const handleClickRadioButton = (isWompay, isOtherWay) => {
    if (isWompay) {
      setPayWithWompay(true);
      setPayWithOtherWay(false);
    }
    if (isOtherWay) {
      setPayWithWompay(false);
      setPayWithOtherWay(true);
    }
  };

  const handlePay = () => {
    GoogleTagManager.tagInteractiveEvent({
      eventCategory: 'Modal de Pago - Medios de Pagos',
      eventAction: `Presionar Botón - Pagar`,
      eventTag: 'Modal de Pago - Pagar',
    });
    if (payWithOtherWay) {
      redirectToExternalPage(paymentUrl, false);
    } else if (payWithWompay) {
      redirectToWompay(`pay/${transactionIdWomPay}`);
    }
  };

  const loadingModal = (
    <ModalContainerStyled>
      <ModalStyled>
        <Spinner size={70} width={10} />
        <strong>Cargando</strong>
      </ModalStyled>
    </ModalContainerStyled>
  );

  const disclaimer = (
    <>
      <DisclaimerKushkiStyled>
        Tus tarjetas registradas dejarán de funcionar, desvincula y registra
        nuevamente tus tarjetas para continuar.{' '}
        <Link to="/marketplace/metodos-de-pago">Actualizar mis tarjetas</Link>
      </DisclaimerKushkiStyled>
    </>
  );

  const disclaimerError = (
    <DisclaimerErrorStyled>
      El acceso a Mis Tarjetas no se encuentra disponible, continúa el pago de
      tu boleta con <strong>Otros medios de pago</strong>
    </DisclaimerErrorStyled>
  );

  const contentToPay = (
    <>
      {loading && loadingModal}
      <PayContainerStyled>
        <PayInfoContainerStyled>
          <PayChipStyled>
            <span>Estás pagando:</span>
            <strong>
              ${Numbers.addThousandSeparators(invoicesStatus?.amountToPay)}
            </strong>
          </PayChipStyled>
          <SelectorPaymentMethodStyled>
            <TitleSelectorStyled>
              <OneCardIcon />
              <h1>¿Cómo quieres pagar?</h1>
            </TitleSelectorStyled>
            <ContainerRadioGroupStyled>
              <ContainerRadioButtonStyled checked={payWithWompay}>
                <Radio
                  name="wompay"
                  value={1}
                  variant="corporate"
                  checked={payWithWompay}
                  disabled={hasKushkiCards || !transactionIdWomPay}
                  onChange={() => handleClickRadioButton(true, false)}
                >
                  Mis tarjetas
                </Radio>
                {payWithWompay && (
                  <DisclaimerWompayStyled>
                    Registra tus tarjetas y paga fácilmente con WOMPAY
                  </DisclaimerWompayStyled>
                )}
              </ContainerRadioButtonStyled>
              <ContainerRadioButtonStyled checked={payWithOtherWay}>
                <Radio
                  name="otherway"
                  value={2}
                  variant="corporate"
                  onChange={() => handleClickRadioButton(false, true)}
                  checked={payWithOtherWay}
                >
                  Otros medios de pago
                </Radio>
              </ContainerRadioButtonStyled>
            </ContainerRadioGroupStyled>
          </SelectorPaymentMethodStyled>
          {hasKushkiCards && (
            <MessageCard variant="warning" detail={disclaimer} />
          )}
          {!hasKushkiCards && !transactionIdWomPay && (
            <MessageCard variant="info" detail={disclaimerError} />
          )}
        </PayInfoContainerStyled>

        <Button
          color="bubbleGum"
          onClick={() => handlePay()}
          disabled={(!payWithOtherWay && !payWithWompay) || loading}
        >
          Pagar
        </Button>
      </PayContainerStyled>
    </>
  );

  const contentPanel = () => {
    if (!loading) return contentToPay;
    if (loading) return <LoadingComponent />;
    return null;
  };

  return (
    <>
      {showPanel && (
        <Panel
          open={showPanel}
          title="Selecciona tu medio de pago"
          onClose={() => {
            setShowPanel(false);
            resetValues();
          }}
        >
          {contentPanel()}
        </Panel>
      )}

      <Button
        color="bubbleGum"
        endIcon={icon || null}
        onClick={() => setShowPanel(true)}
      >
        {title}
      </Button>
    </>
  );
};

PayButton.propTypes = {
  icon: PropTypes.element,
  title: PropTypes.string.isRequired,
  invoicesStatus: PropTypes.shape({
    amountToPay: PropTypes.number,
    debtStatus: PropTypes.string,
    idFolio: PropTypes.string,
  }),
  paymentUrl: PropTypes.string.isRequired,
  last6Invoices: PropTypes.shape({
    lastInvoice: PropTypes.shape({
      amount: PropTypes.number,
      amountToPay: PropTypes.number,
      dueDate: PropTypes.string,
      month: PropTypes.string,
      documentId: PropTypes.string,
      status: PropTypes.string,
      urlFactura: PropTypes.string,
    }),
    lastSemester: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number,
        amountToPay: PropTypes.number,
        dueDate: PropTypes.string,
        month: PropTypes.string,
        documentId: PropTypes.string,
        status: PropTypes.string,
        urlFactura: PropTypes.string,
      })
    ),
  }),
  accountSelected: PropTypes.string,
};

PayButton.defaultProps = {
  icon: null,
  invoicesStatus: {},
  last6Invoices: [],
  accountSelected: '',
};

export default PayButton;
